import { defineMessages } from 'react-intl'

const scope = 'app.components.FilterableList'

export default defineMessages({
  count: {
    id: `${scope}.count`,
    defaultMessage: '{count} {count, plural, one {{type}} other {{type}s}}',
  },
  documentedActivity: {
    id: `${scope}.documentedActivity`,
    defaultMessage: 'Documented Business Activity ({count})',
  },
  option: {
    id: `${scope}.option`,
    defaultMessage: '{label} ({count})',
  },
  filters: {
    id: `${scope}.filters`,
    defaultMessage: 'Filters',
  },
})
